var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/bag-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bag-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.1233 12.3268C22.5603 12.3268 22.0935 11.8599 22.0935 11.297V9.40214C22.0935 7.96043 21.4756 6.55991 20.4046 5.58503C19.3199 4.59643 17.9194 4.14332 16.4365 4.28063C13.965 4.51405 11.7956 7.04048 11.7956 9.67675V11.0086C11.7956 11.5716 11.3287 12.0384 10.7658 12.0384C10.2028 12.0384 9.73596 11.5716 9.73596 11.0086V9.66302C9.73596 5.96949 12.7155 2.56431 16.2443 2.22104C18.3039 2.02881 20.2811 2.67415 21.7914 4.06094C23.2881 5.42027 24.1531 7.37001 24.1531 9.40214V11.297C24.1531 11.8599 23.6862 12.3268 23.1233 12.3268Z",
    fill: "#171212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.0636 31.7143H12.8253C6.48173 31.7143 5.3009 28.7622 4.99882 25.8925L3.96903 17.6679C3.81799 16.185 3.76307 14.0568 5.20478 12.464C6.44054 11.091 8.48639 10.4319 11.4522 10.4319H22.4367C25.4162 10.4319 27.4621 11.1047 28.6841 12.464C30.1121 14.0568 30.0709 16.185 29.9198 17.6404L28.8901 25.8925C28.588 28.7622 27.4071 31.7143 21.0636 31.7143ZM11.4522 12.4915C9.13173 12.4915 7.53898 12.9446 6.72888 13.8508C6.05608 14.5923 5.83639 15.7319 6.01489 17.4345L7.04468 25.6591C7.2781 27.856 7.88225 29.6684 12.8253 29.6684H21.0636C26.0066 29.6684 26.6108 27.8697 26.8442 25.6866L27.874 17.4345C28.0525 15.7594 27.8328 14.6197 27.16 13.8645C26.3499 12.9446 24.7571 12.4915 22.4367 12.4915H11.4522Z",
    fill: "#171212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21.6405 18.533C20.8715 18.533 20.2537 17.9151 20.2537 17.1599C20.2537 16.4047 20.8715 15.7869 21.6267 15.7869C22.3819 15.7869 22.9998 16.4047 22.9998 17.1599C22.9998 17.9151 22.3956 18.533 21.6405 18.533Z",
    fill: "#171212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.029 18.533C11.2601 18.533 10.6422 17.9151 10.6422 17.1599C10.6422 16.4047 11.2601 15.7869 12.0153 15.7869C12.7705 15.7869 13.3883 16.4047 13.3883 17.1599C13.3883 17.9151 12.7842 18.533 12.029 18.533Z",
    fill: "#171212"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.8e1ba6370270a6d45e95645e7963408c.svg";
export { ForwardRef as ReactComponent };